import toastMessage from "../../toastMessage";
import formatSelectData from "../../formatSelectData";
import { getStorage } from "../../storage";
import language from "../../../language";
import api from "../../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchBloodTestQuestionnaire = async (lng = "english", params) => {
  const { page, limit, type, q } = params || {};

  const { token } = await getStorage();
  try {
    const options = {
      method: "GET",
      url: `${API_URL}/blood-test-questionnaire`,
      params: {
        page: page,
        limit: limit,
        type,
        q,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      return formatSelectData(
        queryRes?.data?.data || queryRes?.data,
        "code",
        "_id"
      );
    }

    return !page && !limit
      ? queryRes.data
      : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteBloodTestQuestionnaire = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/blood-test-questionnaire`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_data);
  } catch (error) {
    toastMessage("error", error);
  }
};
